import { ISigningCaseListItem } from 'src/models';
import { isSigningCaseReadyToSign } from 'src/utils/SigningCase';
import { lightBlue, transparentBlue } from 'src/styles';

interface RowProps {
  contractingPartyType: ISigningCaseListItem['contractingPartyType'];
  documentStatus: ISigningCaseListItem['status'];
}

const isCompanyDocumentNotSigned = (
  contractingPartyType: ISigningCaseListItem['contractingPartyType'],
  documentStatus: ISigningCaseListItem['status']
): boolean => {
  return (
    contractingPartyType === 'Company' &&
    isSigningCaseReadyToSign(documentStatus)
  );
};

export const getBackgroundColor = (props: RowProps) => {
  if (
    isCompanyDocumentNotSigned(props.contractingPartyType, props.documentStatus)
  ) {
    return '#EFF6F9';
  } else {
    return 'white';
  }
};

export const getBackgroundHoverColor = (props: RowProps) => {
  if (
    isCompanyDocumentNotSigned(props.contractingPartyType, props.documentStatus)
  ) {
    return lightBlue;
  } else {
    return transparentBlue;
  }
};
